import React from 'react';
import { Drawer, Skeleton, Empty } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

const SCROLL_ID = 'dashboard-detail-drawer-scroll';

// generic "click a dashboard tile, see the records behind it" panel - takes a
// column config + the accumulated rows from useDashboardTileDetail below and
// renders them as an infinite-scrolling list inside a Drawer
export const DashboardDetailDrawer = ({
  open,
  title,
  totalCount,
  onClose,
  columns,
  rows,
  loading,
  hasMore,
  onLoadMore,
  emptyText = 'No records found.',
  // optional: a row's link (e.g. its duty on the schedule) - a click opens it in a new tab
  rowHref,
}) => {
  const gridTemplate = columns.map(c => c.width || '1fr').join(' ');

  return (
    <Drawer
      title={
        <span>
          {title}
          {typeof totalCount === 'number' && !Number.isNaN(totalCount) ? (
            <span style={{ fontWeight: 400, color: '#8c8c8c', fontSize: 13 }}> ({totalCount})</span>
          ) : null}
        </span>
      }
      open={open}
      // onClose={onClose}
      closeIcon={<FontAwesomeIcon icon={faClose} onClick={onClose} className='close-icon' style={{marginRight:'20px'}}/>}

      width={Math.min(820, typeof window !== 'undefined' ? window.innerWidth - 32 : 820)}
      destroyOnClose
      bodyStyle={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <div id={SCROLL_ID} style={{ flex: 1, overflow: 'auto' }}>
        {loading && rows.length === 0 ? (
          <Skeleton active paragraph={{ rows: 6 }} />
        ) : rows.length === 0 ? (
         <div className="text-muted pt20">
          {emptyText}
         </div>
        ) : (
          <>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: gridTemplate,
                gap: 8,
                padding: '8px 6px',
                borderBottom: '1px solid #f0f0f0',
                position: 'sticky',
                top: 0,
                background: '#fff',
                zIndex: 1,
                fontSize: 12,
                fontWeight: 600,
                color: '#8c8c8c',
              }}
            >
              {columns.map(c => <div key={c.key}>{c.label}</div>)}
            </div>
            <InfiniteScroll
              dataLength={rows.length}
              next={onLoadMore}
              hasMore={hasMore}
              scrollableTarget={SCROLL_ID}
              loader={
                <div style={{ padding: '8px 0' }}>
                  <Skeleton active paragraph={{ rows: 2 }} />
                </div>
              }
              endMessage={
                <div style={{ color: '#bbb', textAlign: 'center', padding: '12px 0', fontSize: '12px' }}>
                  No more records
                </div>
              }
            >
              {rows.map((row, index) => {
                const href = rowHref?.(row);
                // controls inside a row (e.g. Fulfill) keep working; anywhere else opens the record
                const open = (e) => {
                  if (!href || e.target.closest('button, a, input, .ant-select, .ant-dropdown, .ant-btn, [role="button"]')) return;
                  window.open(href, '_blank', 'noopener');
                };
                return (
                <div
                  key={row?._id || index}
                  className={href ? 'dash-detail-row linked' : 'dash-detail-row'}
                  onClick={open}
                  title={href ? 'Open in a new tab' : undefined}
                  data-row-href={href || undefined}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: gridTemplate,
                    gap: 8,
                    padding: '10px 6px',
                    borderBottom: '1px solid #f7f7f7',
                    fontSize: 12,
                    alignItems: 'center',
                    color:'#33475b'
                  }}
                >
                  {columns.map((c, ci) => (
                    <div key={c.key} style={{ overflow: 'hidden', textOverflow: 'ellipsis', color:'#33475b' }}>
                      {ci === 0 && href ? <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="dash-detail-open" /> : null}
                      {c.render ? c.render(row) : (row?.[c.key] ?? '-')}
                    </div>
                  ))}
                </div>
                );
              })}
            </InfiniteScroll>
          </>
        )}
      </div>
    </Drawer>
  );
};
